import * as React from 'react'
import SanityBlock from './SanityBlock'
import ImageWithCaption from './ImageWithCaption'

export default function StatGrid({ stats, config }) {
	return (
		<dl className="flex flex-wrap items-start gap-4 gap-y-8 text-center">
			{stats?.map((stat, key) => (
				<div
					className="mx-auto grid basis-[200px] gap-3 text-balance"
					key={key}
				>
					{stat.image && (
						<ImageWithCaption
							className="[&_img]:mx-auto"
							image={stat.image}
							config={config}
						/>
					)}

					<dt className="text-4xl">
						{stat.stat}
						{stat.unit && <small>{stat.unit}</small>}
					</dt>
					<dd className="technical text-sm">
						<SanityBlock body={stat.content} />
					</dd>
				</div>
			))}
		</dl>
	)
}
